import React, { useState } from 'react';
import {
    Card,
    CardContent,
    Typography,
    Box,
    IconButton,
    Collapse,
    List,
    ListItem,
    ListItemText,
    Tooltip
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Groups, ExpandMore, ExpandLess, Visibility } from '@mui/icons-material';
import dayjs from 'dayjs';
import {t} from "i18next";

export default function UserGroups({ groups = [] }) {
    const [expanded, setExpanded] = useState(false);
    const navigate = useNavigate();

    if (!groups.length) return null;

    return (
        <Card
            elevation={3}
            sx={{
                borderRadius: 3,
                overflow: 'hidden',
                mb: 3,
                backgroundColor: '#ffffff'
            }}
        >
            <CardContent
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    cursor: 'pointer',
                    p: 2
                }}
                onClick={() => setExpanded(!expanded)}
            >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Groups sx={{ fontSize: 44, color: '#1976d2', mr: 2 }} />
                    <Box>
                        <Typography variant="h5" fontWeight={600}>
                            {groups.length}
                        </Typography>
                        <Typography variant="body1" color="text.secondary">
                            {groups.length === 1
                                ? t('userPage.group')
                                : t('userPage.groups')}
                        </Typography>
                    </Box>
                </Box>

                <IconButton>{expanded ? <ExpandLess /> : <ExpandMore />}</IconButton>
            </CardContent>

            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <Box sx={{ borderTop: '1px solid #eee', px: 2, pb: 2 }}>
                    <List dense>
                        {groups.map((group) => (
                            <ListItem
                                key={group.uuid}
                                onClick={() => navigate(`/grupos/${group.uuid}`)}
                                sx={{
                                    borderRadius: 2,
                                    mb: 0.5,
                                    cursor: 'pointer',
                                    '&:hover': {
                                        backgroundColor: 'rgba(25, 118, 210, 0.08)'
                                    }
                                }}
                            >
                                <ListItemText
                                    primary={
                                        <Typography variant="body1" fontWeight={500}>
                                            {group.name}
                                        </Typography>
                                    }
                                    secondary={`${dayjs(group.start_date).format('DD/MM/YYYY')} – ${dayjs(group.end_date).format('DD/MM/YYYY')}`}
                                />
                            </ListItem>
                        ))}
                    </List>
                </Box>
            </Collapse>
        </Card>
    );
}
